// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2006) return "static/chunks/2006.65368b7c1fd23098.js";
	if (chunkId === 5496) return "static/chunks/5496.03e4ee07edc8b55a.js";
	if (chunkId === 5525) return "static/chunks/5525.0294ea9339bfc273.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3269 ? "5651de16" : chunkId) + "-" + {"3269":"babeb2881e079956","3571":"5b1d6d5ae3885363","7988":"a4f63ea2d77eed67","9467":"c97a9e7dc2e2f5ae"}[chunkId] + ".js";
};